import { Maybe, TransactionRecordEnumType } from "generated/graphql";
import cn from "classnames";
import styles from "./RecordTypeLabel.module.scss";

interface RecordTypeLabelProps {
  recordType: Maybe<TransactionRecordEnumType> | undefined;
}

export const RecordTypeLabel = ({ recordType }: RecordTypeLabelProps) => {
  return <span className={cn(styles.record_type_label)}>{recordType}</span>;
};
